import React, { Dispatch, SetStateAction, Suspense, useCallback, useContext, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import IconConnection from '../../../../components/iconConnection/iconConnection';
import './homeTopBarDesktop.css';

import logoWhite from "../../../../image/logo/logoWhite.svg";
import { PiCalendarDotsLight } from 'react-icons/pi';
import {  countMiniRestoResults, CurrentCity, getAllPresentFilterFromMiniRestos, getContextualMiniRestos, getInitialCurrentCity, getRandomSuggestions, getVisibleDateHour, MultiSearchResult, useSeoSearchAnchor } from '../../SearchPage/hookSearchPage';
import { Coordonates, FilterValue, formatFilterLabel, getCuisineDisplayLabel, TIME_FILTERS } from '../../../../components/types/types';
import { AppContext } from '../../../../context/AppContext';
import topBarImg from "../../../../image/topBar/topBarImg_hight.webp";
import { TfiClose } from 'react-icons/tfi';
import { ImMap2 } from 'react-icons/im';
import imgMap from '../../../../image/blocMap.webp'
import { RestaurantContext } from '../../../../context/RestaurantContext';
import { FaSliders } from 'react-icons/fa6';
import FilterBar from '../../Body/Filter/FilterBar';
import CalendarMobile from '../../SearchPage/components/calendarMobile';
import { CitySearchDesktop, MultiSearchDesktop } from './hookTopBarDesktop';
import { FiInfo } from 'react-icons/fi';
import ChunkErrorBoundary from '../../../../components/hook/chunkErrorBoundary';
import { useViewportMaxHeight } from '../../../../components/hook/hookViewPortHeight';

const ShowAllCuisine = React.lazy(() => import("../../../../components/showAllFilters/showAllCuisine"));
const ShowAllType = React.lazy(() => import("../../../../components/showAllFilters/showAllType"));
const CantProximity = React.lazy(() => import("../../../../components/cantProximity/cantProximity"));

const useTopBarScrollStateDesktop = (topBarHeight: number) => {
  const [toolbarFixed, setToolbarFixed] = useState(false);
  const rafRef = useRef<number | null>(null);

  useEffect(() => {
    const isCoarse = window.matchMedia("(pointer: coarse)").matches;
    if (
        (isCoarse && window.innerWidth <= 460) ||
        (!isCoarse && window.innerWidth <= 700)
    ) {
        return;
    }

    const update = () => {
      const y = window.scrollY || document.documentElement.scrollTop || 0;
      setToolbarFixed(y >= topBarHeight - 100);
    };

    update();
    
    const onScroll = () => {
      if (rafRef.current !== null) return;

      rafRef.current = requestAnimationFrame(() => {
        rafRef.current = null;
        update();
      });
    };

    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", onScroll);
      if (rafRef.current !== null) cancelAnimationFrame(rafRef.current);
    };
  }, [topBarHeight]);

  return { toolbarFixed };
};
const removeTimeFilters = (filters: FilterValue[]) => {
    return filters.filter(
        filter =>
            typeof filter !== "string" ||
            !TIME_FILTERS.has(filter)
    );
};


interface HomeTopBarDesktopProps {
    resetHome:() => void,

    routeCity: string;
    globalFilter: FilterValue[];
    setGlobalFilter: Dispatch<SetStateAction<FilterValue[]>>;

    currentNeighborhood:string[],
    setCurrentNeighborhood:Dispatch<SetStateAction<string[]>>,
    setShowWaitingSearch: Dispatch<SetStateAction<boolean>>;
}

const HomeTopBarDesktop:React.FC<HomeTopBarDesktopProps> = ({routeCity,resetHome,globalFilter,setGlobalFilter, setCurrentNeighborhood,setShowWaitingSearch,currentNeighborhood}) => {
  const {setSearchFilterValue,coordonates,setCoordonates,indexablePages,connectionScreen, setShowCookies,setPreferencesCookies,setIntentGoMap,setFilterChoose,intentGoMap,setDate_selected,setHour_selected,date_selected,hour_selected} = useContext(AppContext)
  const {miniRestos,miniRestosLoaded,fetchMiniRestos,resetCityRestaurants} = useContext(RestaurantContext)
  const navigate = useNavigate();
  const location = useLocation();
  const [showPopupDate,setShowPopupDate] = useState(false)

  const [showFilterBar,setShowFilterBar] = useState(false)
  const { toolbarFixed } = useTopBarScrollStateDesktop(320);

  const [showAllDesktop,setShowAllDesktop] = useState(0)

  const [keepToolbarFixed, setKeepToolbarFixed] = useState(false);
  const [cantProximity,setCantProximity] = useState(false)
  const savedScrollCantProximityRef = useRef(0);

    useEffect(() => {
        if (!cantProximity) return;
        const isComputer = window.matchMedia("(min-width: 701px)").matches;
        if (!isComputer) return;
        savedScrollCantProximityRef.current = window.scrollY;
        document.body.classList.add("scroll-lock");
        document.body.style.top = `-${savedScrollCantProximityRef.current}px`;

        return () => {
            const savedY = savedScrollCantProximityRef.current;
            document.body.classList.remove("scroll-lock");
            document.body.style.top = "";

            window.scrollTo(0, savedY);
        };
    }, [cantProximity]);
    const wasToolbarFixedBeforeShowAll = useRef(false);
    const previousConnectionScreenRef = useRef(connectionScreen);
    const toolbarFixedBeforeConnectionRef = useRef(toolbarFixed);

    const fixedToolbarRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
    const isIPad =
        /iPad/.test(navigator.userAgent) ||
        (
            navigator.platform === "MacIntel" &&
            navigator.maxTouchPoints > 1
        );

    if (!isIPad) return;

    const vv = window.visualViewport;
    if (!vv) return;

    let raf: number | null = null;
    let previousTop = -999;

    const updateTop = () => {
        if (raf !== null) return;

        raf = requestAnimationFrame(() => {
            raf = null;
            const rawTop = Math.max(0,Math.min(100, vv.offsetTop));
            if (Math.abs(rawTop - previousTop) < 0.75) {
                return;
            }
            previousTop = rawTop;

            fixedToolbarRef.current?.style.setProperty(
                "--ipad-home-top",
                `${rawTop}px`
            );
        });
    };

    updateTop();

    vv.addEventListener("resize", updateTop);
    vv.addEventListener("scroll", updateTop);

    return () => {
        vv.removeEventListener("resize", updateTop);
        vv.removeEventListener("scroll", updateTop);

        if (raf !== null) {
            cancelAnimationFrame(raf);
        }
    };
}, []);

    useLayoutEffect(() => {
        const wasOpen = previousConnectionScreenRef.current;
        if (!wasOpen && connectionScreen) {
            toolbarFixedBeforeConnectionRef.current = toolbarFixed;
        }
        if (wasOpen && !connectionScreen) {
            if (toolbarFixedBeforeConnectionRef.current) {
                setKeepToolbarFixed(true);

                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        setKeepToolbarFixed(false);
                    });
                });
            }
        }

        previousConnectionScreenRef.current = connectionScreen;
    }, [connectionScreen, toolbarFixed]);
    const handleSetCantProximity: Dispatch<SetStateAction<boolean>> = (value) => {
        setCantProximity(prev => {
            const nextValue = typeof value === "function" ? value(prev) : value;
            if (!prev && nextValue) wasToolbarFixedBeforeShowAll.current = toolbarFixed;
            return nextValue;
        });
    };
    const closeCantProximity = () => {
        const wasFixed = wasToolbarFixedBeforeShowAll.current;
        if (wasFixed) setKeepToolbarFixed(true);
        setCantProximity(false);
        if (wasFixed) {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {setKeepToolbarFixed(false);wasToolbarFixedBeforeShowAll.current = false; });
            });
        } else wasToolbarFixedBeforeShowAll.current = false;
    };
  const handleSetShowAllDesktop: Dispatch<SetStateAction<number>> = (value) => {
        setShowAllDesktop(prev => {
            const nextValue = typeof value === "function" ? value(prev) : value;
            if (prev === 0 && nextValue > 0) wasToolbarFixedBeforeShowAll.current = toolbarFixed;
            return nextValue;
        });
    };

    const closeShowAllDesktop = () => {
        const wasFixed = wasToolbarFixedBeforeShowAll.current;
        if (wasFixed) setKeepToolbarFixed(true);
        setShowAllDesktop(0);
        if (wasFixed) {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {setKeepToolbarFixed(false);wasToolbarFixedBeforeShowAll.current = false; });
            });
        } else wasToolbarFixedBeforeShowAll.current = false;
    };

  const [showPopupMultiSearch, setShowPopupMultiSearch] = useState(false);

  
    const [currentDate,setCurrentDate] = useState<Date |null>(date_selected)
    const [currentHour,setCurrentHour] = useState(hour_selected)
    const [currentFilter, setCurrentFilter] = useState<FilterValue[]>(removeTimeFilters(globalFilter));
    const [showCantSearch,setShowCantSearch] = useState(false)
    useEffect(() => {
        if (!showCantSearch) return;
        const timeout = setTimeout(() => {
            setShowCantSearch(false);
        }, 5000);
        return () => clearTimeout(timeout);
    }, [showCantSearch]);

    useEffect(() => {
        setCurrentDate(date_selected)
    },[date_selected])
    useEffect(() => {
        setCurrentHour(hour_selected)
    },[hour_selected])
    useEffect(() => {
        setCurrentFilter(removeTimeFilters(globalFilter));
    }, [globalFilter]);


  const [showPopupCity,setShowPopupCity] = useState(false)
  const [currentCity,setCurrentCity] = useState<CurrentCity | null>(null)
  const [impossibleCity,setImpossibleCity] = useState(false)

  const initialNeighborhoodRef = useRef<string[]>(currentNeighborhood);
    const initialRouteCityRef = useRef(routeCity);
    useEffect(() => {
        const currentRouteCity = getInitialCurrentCity(routeCity, indexablePages);
        const isStillOnInitialCity = !currentCity || currentCity?.slug === currentRouteCity?.slug;
        if (!isStillOnInitialCity) return;

        initialNeighborhoodRef.current = [...currentNeighborhood];
        initialRouteCityRef.current = routeCity;
    }, [routeCity,currentNeighborhood,currentCity,indexablePages]);

    useEffect(() => {
        if (!impossibleCity) return;

        const timeout = setTimeout(() => {
            setImpossibleCity(false);
        }, 3500);

        return () => clearTimeout(timeout);
    }, [impossibleCity]);

  useEffect(() => {
      if (!routeCity) {
        setCurrentCity(null)
        return;
      }
      setCurrentCity(getInitialCurrentCity(routeCity, indexablePages));
  }, [routeCity, indexablePages]);


    useEffect(() => {
        fetchMiniRestos();
    }, [fetchMiniRestos]);
    const presentSearchFilters = useMemo(() => {
        return getAllPresentFilterFromMiniRestos(miniRestos);
    }, [miniRestos]);
  
    const suggestions = useMemo<MultiSearchResult[]>(() => {
        return getRandomSuggestions(miniRestos, 5).map(resto => ({
            kind: "restaurant",
            label: resto.name,
            restaurant: resto
        }));
    }, [miniRestos]);
    const contextualDistance = currentCity?.slug === "restaurants-a-proximite" ? 5 : null;
    const canGoToFilter = useCallback((nextDate: Date | null, nextHour: string) => {
        if (!miniRestosLoaded) return false;
        const nextContextualRestos = getContextualMiniRestos(miniRestos,currentCity,nextDate,nextHour,coordonates,contextualDistance,currentNeighborhood);
        
        const nextCount = countMiniRestoResults(nextContextualRestos,currentFilter,presentSearchFilters);
        if (nextCount === 0) {
            setShowCantSearch(true);
            return false;
        }
        setShowCantSearch(false);
        return true;
    },[miniRestosLoaded,miniRestos,currentCity,coordonates,contextualDistance,currentFilter,presentSearchFilters,currentNeighborhood]);
  const handleHour = (time: string) => {
    const nextDate = currentDate ?? new Date();
    const nextHour = currentHour === time ? "" : time;
    if (!currentDate) setCurrentDate(nextDate);
    setCurrentHour(nextHour);
    if (nextHour && canGoToFilter(nextDate, nextHour)) handleFilter();
  };
  const handleClickDay = (day: Date) => {
     const nextDate = currentDate?.getTime() === day.getTime() ? null : day;
      setCurrentDate(nextDate);
      if (!nextDate) {
         setCurrentHour("");
        setShowCantSearch(false);
        return;
    }
      const canGo = canGoToFilter(nextDate, currentHour);
      if (currentHour && canGo) handleFilter();
  };

  const closeTopbar = () => {
    setShowPopupMultiSearch(false);
    setShowPopupCity(false);
    setShowPopupDate(false);
    setShowFilterBar(false);
    setActiveMask(null);
    setShowCantSearch(false);
    setImpossibleCity(false);
};


const cancelTopbar = () => {
    closeTopbar();

    setCurrentHour(hour_selected);
    setCurrentDate(date_selected);

    setCurrentFilter(removeTimeFilters(globalFilter));
    setCurrentCity(getInitialCurrentCity(routeCity,indexablePages));
};
    useEffect(() => {
    const isTablet = window.matchMedia(
        "(min-width: 701px) and (pointer: coarse)"
    ).matches;

    if (!isTablet) return;

    const isSomethingOpen =
        showPopupMultiSearch ||
        showPopupCity ||
        showPopupDate ||
        showFilterBar;

    if (!isSomethingOpen) return;

    const CLOSE_THRESHOLD = 400;

    let referenceScrollY = window.scrollY;

    let userScrollStarted = false;
    let hasBlurredInput = false;

    let armed = true;
    let armTimeout: number | null = null;

    const isEditableElement = (
        element: Element | null
    ) => {
        return (
            element instanceof HTMLInputElement ||
            element instanceof HTMLTextAreaElement ||
            element?.getAttribute("contenteditable") === "true"
        );
    };

    const armAfterFocus = () => {
        armed = false;
        userScrollStarted = false;
        hasBlurredInput = false;

        if (armTimeout !== null) {
            window.clearTimeout(armTimeout);
        }

        armTimeout = window.setTimeout(() => {
            referenceScrollY = window.scrollY;
            armed = true;
        }, 350);
    };

    const handleFocusIn = (event: FocusEvent) => {
        if (
            !isEditableElement(
                event.target as Element
            )
        ) {
            return;
        }

        armAfterFocus();
    };

    const handleTouchMove = () => {
        if (!armed) {
            return;
        }
        if (!userScrollStarted) {
            userScrollStarted = true;
            referenceScrollY = window.scrollY;
        }
        const activeElement = document.activeElement;
        if (!hasBlurredInput &&isEditableElement(activeElement)) {
            hasBlurredInput = true;
            (activeElement as HTMLElement).blur();
        }
    };
    const handleTabletScroll = () => {
        if (!armed || !userScrollStarted) {
            return;
        }
        const distance = Math.abs(
            window.scrollY -
            referenceScrollY
        );
        if (distance <CLOSE_THRESHOLD) {
            return;
        }
        cancelTopbar();
    };

    document.addEventListener(
        "focusin",
        handleFocusIn
    );

    window.addEventListener(
        "touchmove",
        handleTouchMove,
        { passive: true }
    );

    window.addEventListener(
        "scroll",
        handleTabletScroll,
        { passive: true }
    );

    return () => {
        document.removeEventListener("focusin",handleFocusIn);
        window.removeEventListener("touchmove",handleTouchMove);
        window.removeEventListener("scroll",handleTabletScroll);
        if (armTimeout !== null) {window.clearTimeout(armTimeout);
        }
    };

}, [showPopupMultiSearch,showPopupCity,showPopupDate,showFilterBar,]);

    const searchPartRef = useRef<HTMLDivElement>(null);
    const cityPartRef = useRef<HTMLDivElement>(null);
    const hourPartRef = useRef<HTMLDivElement>(null);
    const filterPartRef = useRef<HTMLDivElement>(null);

    const [activeMask, setActiveMask] = useState<'search' | 'city' | 'hour' | 'filter' | null>(null);

    
    const [maskStyle, setMaskStyle] = useState({left: 0,width: 0});
    const [maskInstant, setMaskInstant] = useState(false);
    const activeMaskRef = useRef<"search" | "city" | "hour" | "filter" | null>(null);
    useEffect(() => {
        activeMaskRef.current = activeMask;
    }, [activeMask]);
    const moveMaskTo = useCallback((target: "search" | "city" | "hour" | "filter") => {
        const refs = {search: searchPartRef,city: cityPartRef,hour: hourPartRef,filter: filterPartRef};

        const elem = refs[target].current;
        const container = refAllSearchBar.current;
        if (!elem || !container) return;
        const elemRect = elem.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        const isSmallDesktop = window.innerWidth < 1200;

        const leftMinus = target === "search" ? (isSmallDesktop ? 12 : 20) : (isSmallDesktop ? 25 : 40);
        const widthAdd = target === "search" ? (isSmallDesktop ? 20 : 30) : (isSmallDesktop ? 50 : 80);

        const newStyle = {left: elemRect.left - containerRect.left - leftMinus,width: elemRect.width + widthAdd};

        if (activeMaskRef.current === null) {
            setMaskInstant(true);
            setMaskStyle(newStyle);
            setActiveMask(target);

            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    setMaskInstant(false);
                });
            });
            return;
        }

        setMaskStyle(newStyle);
        setActiveMask(target);
    },[]);

  const handleCity = useCallback(() => {
      setShowPopupDate(false);
      setShowFilterBar(false);
      setShowPopupMultiSearch(false);
      setShowPopupCity(true)
      moveMaskTo('city');
  }, [moveMaskTo]);
  const handleSearch = useCallback(() => {
      setShowPopupDate(false);
      setShowFilterBar(false);
      setShowPopupCity(false)
      setShowPopupMultiSearch(true);
      moveMaskTo('search');
  }, [moveMaskTo]);
  const handleDate = useCallback(() => {
      setShowPopupDate(true);
      setShowFilterBar(false);
      setShowPopupCity(false)
      setShowPopupMultiSearch(false);
      moveMaskTo('hour');
  }, [moveMaskTo]);
  const handleFilter = () => {
      setSearchFilterValue("");
      setShowPopupDate(false);
      setShowFilterBar(true);
      setShowPopupCity(false)
      setShowPopupMultiSearch(false);
      moveMaskTo('filter');
  }


  const handleClickCity = useCallback((city: CurrentCity) => {
        if (city?.name === "À proximité") {

            if (!navigator.geolocation) {
                handleSetCantProximity(true);
                return;
            }
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const userLocation: Coordonates = {
                    latitude: position.coords.latitude.toString(),
                    longitude: position.coords.longitude.toString(),
                    };
                    setCoordonates(userLocation);
                    setCurrentCity(city);
                    setCurrentNeighborhood([]);
                    handleDate();
                },
            () => {
                handleSetCantProximity(true);
                return;
            }
            );
            
            return;
        }
         if (city?.slug === initialRouteCityRef.current) {
            setCurrentNeighborhood(initialNeighborhoodRef.current);
        } else {
            setCurrentNeighborhood([]);
        }
        setCurrentCity(city);
        if(showPopupCity) handleDate()
   }, [ handleDate, showPopupCity,setCurrentNeighborhood]);
   const handleSetCurrentCity: React.Dispatch<React.SetStateAction<CurrentCity | null>> = (value) => {
        setCurrentCity(prev => {
            const next = typeof value === "function" ? value(prev) : value;
            if (!next) {
                setCurrentNeighborhood(initialNeighborhoodRef.current);
            }
            return next;
        });
    };
  
    useEffect(() => {
        if(cantProximity) setCurrentCity(null)
    },[cantProximity])

  const handleMap = () => {
        const cookie = document.cookie.split('; ').find(row => row.startsWith('QUELRESTO_COOKIE='));
        if (cookie) {
            const cookieValue = cookie.split('=')[1];
            try {
                const decode = decodeURIComponent(cookieValue)
                const cookieData = JSON.parse(decode);
                if (cookieData['perform-analytics']) {
                    setShowFilterBar(false)
                    navigate(`/map?via=home`, {state: {routeCity,returnTo: `${location.pathname}${location.search}`,returnState: {...(location.state ?? {}),topBarMode: "search"}}});
                } else {
                    setShowCookies(true)
                    setPreferencesCookies(true) 
                    setIntentGoMap(1)
                }
            } catch (error) {
                setShowCookies(true)
                setPreferencesCookies(true)
                setIntentGoMap(1)
            }
        } else {
            setShowCookies(true)
            setPreferencesCookies(true)
            setIntentGoMap(1)
        }
    }
    useEffect(() => {
        if(intentGoMap === 2) {
            setShowFilterBar(false)
            setIntentGoMap(0)
            navigate(`/map?via=home`, {state: {routeCity,returnTo: `${location.pathname}${location.search}`,

        returnState: {
            ...(location.state ?? {}),
            topBarMode: "search"
        }}});
        }
    },[intentGoMap])

    

    const refAllSearchBar = useRef<HTMLDivElement>(null);
    const showAllDesktopRef = useRef<HTMLDivElement>(null);
    const cantProximityRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        const handleClickOutsideSearchBar = (event: MouseEvent) => {
            const target = event.target as Node;
            const isInsideTopBar = refAllSearchBar.current?.contains(target);
            const isInsideShowAll = showAllDesktopRef.current?.contains(target);
            const isInsideCantProximity = cantProximityRef.current?.contains(target);
            if (!isInsideTopBar && !isInsideShowAll && !isInsideCantProximity) {
                setActiveMask(null);
                cancelTopbar();
            }
        };
        document.addEventListener('mousedown', handleClickOutsideSearchBar);
        return () => {
            document.removeEventListener(
                'mousedown',
                handleClickOutsideSearchBar
            );
        };
    }, [hour_selected,date_selected,globalFilter,routeCity,indexablePages]);
    const filterHomeHeightLimit = window.innerWidth < 1000 ? 600 : null;
    const {ref: multiSearchPopupRef,maxHeight: multiSearchMaxHeight} = useViewportMaxHeight(showPopupMultiSearch,[toolbarFixed]);
    const {ref: filterHomePopupRef,maxHeight: filterHomeMaxHeight} = useViewportMaxHeight(showFilterBar,[toolbarFixed],150,10,filterHomeHeightLimit);
    const {ref: datePopupRef,maxHeight: dateMaxHeight} = useViewportMaxHeight(showPopupDate,[toolbarFixed]);


    const contextualMiniRestos = useMemo(() => {
        if (!miniRestosLoaded) return [];
        return getContextualMiniRestos(
            miniRestos,
            currentCity,
            currentDate,
            currentHour,
            coordonates,
            contextualDistance,
            currentNeighborhood
        );
    }, [miniRestosLoaded, miniRestos, currentCity, currentDate, currentHour,coordonates,contextualDistance,currentNeighborhood]);
    const resultCount = useMemo(() => {
        if (!miniRestosLoaded) return null;
        return countMiniRestoResults(
            contextualMiniRestos,
            currentFilter,
            presentSearchFilters
        );
    }, [miniRestosLoaded, contextualMiniRestos, currentFilter,presentSearchFilters]);
    const {shouldKeepCurrentSeoPath} = useSeoSearchAnchor({pathname: location.pathname,indexablePages,currentFilter,currentCitySlug: currentCity?.slug ?? null,});

    const handleLaunchSearch = () => {
        if(!currentDate && currentFilter.length === 0 && !currentHour && !currentCity) {
            setDate_selected(null);
            setHour_selected("");
            setGlobalFilter([]);
            setFilterChoose([])
            setCurrentNeighborhood([])
            navigate("/restaurants", {
                state: { topBarMode: "search" }
            });
            closeTopbar();
            setShowWaitingSearch(true)
            setTimeout(() => {
                setShowWaitingSearch(false)
            },1200)
            return;
        }
        if(resultCount === 0) {
            setShowCantSearch(true)
            return;
        }

        setHour_selected(currentHour)
        setDate_selected(currentDate)
        setGlobalFilter(currentFilter) 
        setFilterChoose(currentFilter)
        if (shouldKeepCurrentSeoPath) {
            closeTopbar();
            setShowWaitingSearch(true);
            setTimeout(() => {
                setShowWaitingSearch(false);
            }, 1200);
            return;
        }
        if (currentCity?.slug) {
            const hasKnownCoordinates = currentCity.name !== "À proximité" && currentCity.latitude && currentCity.longitude;
            navigate(`/${currentCity.slug}`, {
                state: { topBarMode: "search",
                    ...(hasKnownCoordinates
                    ? {
                        knownCity: {
                            name: currentCity.name,
                            cityNameRaw: currentCity.cityNameRaw ?? currentCity.name,
                            slug: currentCity.slug,
                            latitude: currentCity.latitude,
                            longitude: currentCity.longitude
                        }
                    }
                    : {})
                 }
            });
        }else {
            if (routeCity) {
                resetCityRestaurants();
            }
            navigate('/', {
                state: { topBarMode: "search" }
            });
        }
        closeTopbar();
        setShowWaitingSearch(true)
        setTimeout(() => {
            setShowWaitingSearch(false)
        },1200)
    };


    const visibleFilterSummary = useMemo(() => {
        const MAX_CHARACTERS = 22;
        if (currentFilter.length === 0) return "(Type, ambiance, expérience)";
        const labels = currentFilter.map((filter) => getCuisineDisplayLabel(formatFilterLabel(filter)));
        let result = "";
        for (let index = 0; index < labels.length; index++) {
            const label = labels[index];
            const separator = result ? ", " : "";
            const fullCandidate = `${result}${separator}${label}`;
            if (fullCandidate.length <= MAX_CHARACTERS) {
                result = fullCandidate;
                continue;
            }

            const remainingAfterCurrent = labels.length - index - 1;
            const counter = remainingAfterCurrent > 0 ? ` +${remainingAfterCurrent}` : "";
            const ending = `...${counter}`;

            const availableCharacters = MAX_CHARACTERS - result.length - separator.length - ending.length;
            if (availableCharacters > 0) {
                const partialLabel = label.slice(0, availableCharacters);
                return `(${result}${separator}${partialLabel}${ending})`;
            }
            const fullyHiddenCount = labels.length - index;
            const hiddenSuffix = fullyHiddenCount > 0 ? `... +${fullyHiddenCount}` : "...";
            return `(${result}${hiddenSuffix})`;
        }
        return `(${result})`;
    }, [currentFilter]);

    const isActiveTopBar = (showPopupMultiSearch || showPopupCity ||showPopupDate || showFilterBar || connectionScreen);
    const isToolbarFixed = toolbarFixed || ((showAllDesktop > 0 || cantProximity) &&wasToolbarFixedBeforeShowAll.current) || (connectionScreen &&toolbarFixedBeforeConnectionRef.current) || keepToolbarFixed;
  
    return (
    <>
        <div className={'homeTopBarDesk'}>
            <div className="topBarHeroImage">
                <img className="topBarHeroImg" src={topBarImg} alt="" loading="eager" decoding="async" fetchPriority="high" />
                <div className="shadowTopTopBar"></div>
                <div className="shadowGlobalFirst"></div>
                <div className="shadowBottomTopBar"></div>
                <div className="shadowGlobalScnd"></div>
            </div>
            <div className='firstPart'>
                
                <Link to="/" className="containerLogo" onClick={resetHome}>
                    <img className="logoTopBar" src={logoWhite}  alt="logo"/>
                </Link>

                <div className="topBarHeroCatchPhrase largeText">
                    <span className="goldText">Le bon restaurant,</span>
                    <span className="whiteText">selon vos envies.</span>
                </div>

                <IconConnection />
            </div>
            <div className={`scndPart ${isToolbarFixed ? "isFixed" : ""} `} ref={fixedToolbarRef}>
                <div className='borderPart'>
                    {isToolbarFixed ? (
                         <div  className="fixedLogoContainer pointer" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
                            <img src={logoWhite} alt="QuelResto" className="fixedLogo"/>
                        </div>
                    )
                    : <div className="buttonMap midWhiteRoundButton buttonToolBar XsmallText" onClick={handleMap}>
                        <img src={imgMap} decoding="async" loading="lazy" alt="map" />
                        <ImMap2 size={17} className="icon"/>
                        <span className='scndText'>Ouvrir la map</span>
                    </div> }
                </div>
                <div className={`searchBarMoveWrapper ${(showPopupMultiSearch || showPopupCity || showPopupDate || showFilterBar) ? 'isActive' : ''}`}>
                    <div className={`containerAllSearchBar primaryBack ${isActiveTopBar ? 'isActive' : ''}`} ref={refAllSearchBar}>
                        <div className={`sharedMaskBull ${activeMask ? 'isVisible' : ''} ${maskInstant ? 'isInstant' : ''}`} style={{width: `${maskStyle.width}px`,transform: `translateX(${maskStyle.left}px)`}}/>
                        <MultiSearchDesktop  showPopupMultiSearch={showPopupMultiSearch} setShowPopupMultiSearch={setShowPopupMultiSearch} suggestions={suggestions} miniRestos={miniRestos}  multiSearchPopupRef={multiSearchPopupRef} multiSearchMaxHeight={multiSearchMaxHeight} searchPartRef={searchPartRef} handleSearch={handleSearch}/>
                        
                        <div className='separationSearch' style={{marginLeft:'0'}}></div>
                        
                        <CitySearchDesktop showPopupCity={showPopupCity} currentCity={currentCity} setCurrentCity={handleSetCurrentCity} handleClickCity={handleClickCity} handleCity={handleCity} cityPartRef={cityPartRef} miniRestos={miniRestos} impossibleCity={impossibleCity} setImpossibleCity={setImpossibleCity} />
                        <div className='separationSearch'></div>
                        <div className={`hourPart ${showPopupDate ? 'isSelect' : ''}`} ref={hourPartRef}>
                            <div className="basePart pointer lowOpacityHover" onClick={handleDate}>
                                <PiCalendarDotsLight size={15} style={{minWidth:'15px'}} className="icon"/>
                                <div className="basePartTextWrapper">
                                    <span className='textBase smallText'>{getVisibleDateHour(currentDate,currentHour)}</span>
                                </div>
                                {(currentDate || currentHour) && <TfiClose className='iconClose pointer' onClick={(e) => {e.preventDefault();e.stopPropagation();setCurrentDate(null);setCurrentHour('')}}/>}
                            </div>
                            {showPopupDate && <div className='containerPopup primaryBack' ref={datePopupRef} style={dateMaxHeight ? { maxHeight: `${dateMaxHeight}px` } : undefined}>
                                <CalendarMobile handleClickDay={handleClickDay}  currentDate={currentDate} />
                                <div className="selectHourPart XsmallText">
                                    <span className="XsmallTextBold">Service : </span>
                                    <div className={`smallWhiteRoundButton ${currentHour==='12h30' ? 'isSelect' : ''}`} onClick={() => handleHour("12h30")}>Midi</div>
                                    <span className="flexAllCenter">ou</span>
                                    <div className={`smallWhiteRoundButton ${currentHour==='20h00' ? 'isSelect' : ''}`} onClick={() => handleHour("20h00")}>Soir</div>
                                </div>
                            </div>}
                        </div>
                        <div className='separationSearch'></div>
                        <div className={`filterPart ${showFilterBar ? 'isSelect' : ''}`} ref={filterPartRef}>
                            <div className="basePart pointer lowOpacityHover" onClick={handleFilter}>
                                <FaSliders size={14} style={{minWidth:'14px'}} className="icon"/>
                                <div className={`basePartTextWrapper ${currentFilter.length === 0 ? "hasDefaultFilterText" : ""}`}>
                                    <span className='textBase smallText'><strong>Filtres</strong> <span className={`explainFilter longPart ${currentFilter.length > 0 ? 'isActive' : 'defaultFilterText'}`}>{visibleFilterSummary}</span> {currentFilter.length > 0 && <span className={`explainFilter shortPart isActive`}>{`(${currentFilter.length})`}</span>}</span>
                                </div>
                                {currentFilter.length > 0 && <TfiClose className='iconClose pointer' onClick={(e) => {e.preventDefault();e.stopPropagation();setCurrentFilter([])}}/>}
                            </div>
                        </div>
                    {showFilterBar && <div ref={filterHomePopupRef} className="filterHomePopup" style={filterHomeMaxHeight ? { maxHeight: `${filterHomeMaxHeight}px` } : undefined}>
                    <FilterBar isForHome={true} contextualRestos={contextualMiniRestos} currentFilter={currentFilter} setCurrentFilter={setCurrentFilter} showAll={showAllDesktop} setShowAll={handleSetShowAllDesktop} routeCity={routeCity} /></div>}
                    <div className={`containerButtonSearch ${(showPopupCity ||showPopupDate || showFilterBar) ? 'isVisible' : ''}`}>
                        <span className={`midGoldRoundButton XsmallText ${(resultCount === 0) ? 'isLock' : ''}`} onClick={handleLaunchSearch}>
                            {!miniRestosLoaded ? (
                                <><span className='textButtonBase'>Rechercher</span><span className='textButtonScnd'>Voir</span> <span className="countSpinnerLoad" /></>
                            ) : resultCount !== null && (currentCity || currentDate || currentHour || currentFilter.length > 0) ? (
                                <><span className='textButtonBase'>Rechercher</span><span className='textButtonScnd'>Voir</span> <span className="resultCount"> <span className='resultLong'>{`(${resultCount} résultat${resultCount > 1 ? 's':''})`}</span> <span className='resultShort'>{`(${resultCount})`}</span>  </span></>
                            ) : (
                                <><span className='textButtonBase'>Rechercher</span><span className='textButtonScnd'>Voir</span> <span className="resultCount"> <span className='resultLong'>{`(${miniRestos.length} résultat${miniRestos.length > 1 ? 's':''})`}</span> <span className='resultShort'>{`(${miniRestos.length})`}</span> </span></>
                            )}
                        </span>

                        
                    </div>
                    </div>
                    {showCantSearch && isActiveTopBar && resultCount === 0 && <div className="containerCantSearch smallText">
                        <FiInfo className='icon' />
                        <div>
                            <span>Aucun résultat trouvé.</span> <span>{currentFilter.length > 1 ? 'Essayez d’enlever un ou plusieurs filtres.' : 'Essayez de modifier votre recherche.'}</span>
                        </div>
                    </div>}       
                </div>
   
            </div>
        </div>

        {isActiveTopBar && <div className='maskActiveTopBarDesk'></div>}
        <ChunkErrorBoundary>
            <Suspense fallback={null}>
                {cantProximity && <div ref={cantProximityRef}>
                    {cantProximity ? <CantProximity  isForProximity={showPopupCity} shouldLockBack={true} setCantProximity={(value) => {
                            const next =  typeof value === "function" ? value(cantProximity) : value;
                            if (!next) closeCantProximity();
                            else handleSetCantProximity(true);
                        }} canClose={true} canApplyCity={handleClickCity}/> : undefined}
                </div>}
                {showAllDesktop > 0 && <div ref={showAllDesktopRef}>
                    {
                        showAllDesktop === 1 ? 
                            <ShowAllCuisine  contextualRestos={contextualMiniRestos} close={closeShowAllDesktop} routeCity={routeCity ?? ""} currentFilter={currentFilter} setCurrentFilter={setCurrentFilter}/>
                            :
                            (showAllDesktop === 2 || showAllDesktop === 3) && <ShowAllType  contextualRestos={contextualMiniRestos} close={closeShowAllDesktop} routeCity={routeCity ?? ''} showAll={showAllDesktop} currentFilter={currentFilter} setCurrentFilter={setCurrentFilter}/>
                    }
                </div>}
                
            </Suspense>
        </ChunkErrorBoundary>
    </>
  );
}

export default HomeTopBarDesktop 